// File: Api/documentService.js
import axios from "axios";
import { Base_URL } from "../url";

export const documentService = {
  // Upload document
  async uploadDocument(userId, documentType, file) {
    console.group('📤 Document Upload Service');
    console.log('User ID:', userId);
    console.log('Document Type:', documentType);
    console.log('File:', file.name, file.size, file.type);
    
    const formData = new FormData();
    formData.append('file', file);
    formData.append('userId', userId.toString());
    formData.append('documentType', documentType);
    
    try {
      console.log('🔄 Sending upload request...');
      const response = await axios.post(`${Base_URL}/document/upload`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        onUploadProgress: (progressEvent) => {
          const progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          console.log(`📊 Upload Progress: ${progress}%`);
        },
      });
      
      console.log('✅ Upload response:', response.data);
      console.groupEnd();
      return response.data;
    } catch (error) {
      console.error('❌ Upload error:', error.response?.data || error.message);
      console.groupEnd();
      throw error;
    }
  },

  // Delete document
  async deleteDocument(documentId) {
    console.group('🗑️ Document Delete Service');
    console.log('Document ID:', documentId);
    
    try {
      console.log('🔄 Sending delete request...');
      const response = await axios.delete(`${Base_URL}/document/${documentId}`);
      
      console.log('✅ Delete response:', response.data);
      console.groupEnd();
      return response.data;
    } catch (error) {
      console.error('❌ Delete error:', error.response?.data || error.message);
      console.groupEnd();
      throw error;
    }
  },

  // Get user documents - FIXED ENDPOINT
  async getUserDocuments(userId) {
    console.group('📋 Get User Documents Service');
    console.log('User ID:', userId);
    
    try {
      console.log('🔄 Fetching documents...');
      const response = await axios.get(`${Base_URL}/document/user/${userId}`);
      
      console.log('✅ Documents fetched:', response.data);
      console.groupEnd();
      return response.data;
    } catch (error) {
      console.error('❌ Fetch error:', error.response?.data || error.message);
      console.groupEnd();
      // Return empty array instead of throwing error if no documents found
      if (error.response?.status === 404) {
        console.log('📭 No documents found, returning empty array');
        return [];
      }
      throw error;
    }
  }
};